import React, { useState, useEffect } from "react";
import { Modal, Button, Space } from "antd";
import { RiArrowUpLine, RiArrowDownLine } from "react-icons/ri";

const ReorderModal = ({ open, onClose, stations, onReorder }) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (open) {
      setItems(stations);
    }
  }, [open, stations]);

  const moveUp = (index) => {
    if (index === 0) return;
    const newItems = [...items];
    [newItems[index - 1], newItems[index]] = [newItems[index], newItems[index - 1]];
    setItems(newItems);
  };

  const moveDown = (index) => {
    if (index === items.length - 1) return;
    const newItems = [...items];
    [newItems[index], newItems[index + 1]] = [newItems[index + 1], newItems[index]];
    setItems(newItems);
  };

  const handleConfirm = () => {
    onReorder(items);
  };

  return (
    <Modal
      title="調整放置順序"
      open={open}
      onCancel={onClose}
      onOk={handleConfirm}
      okText="確定"
      cancelText="取消"
      width={450}
    >
      <div
        style={{
          marginBottom: 12,
          padding: "8px 12px",
          backgroundColor: "#e6f7ff",
          border: "1px solid #91d5ff",
          borderRadius: 6,
          fontSize: 13,
          color: "#0050b3",
        }}
      >
        使用上下箭頭調整基站的放置順序
      </div>
      <div style={{ maxHeight: 400, overflowY: "auto" }}>
        {items.map((station, index) => (
          <div
            key={station.id}
            style={{
              padding: "12px 16px",
              marginBottom: 8,
              backgroundColor: "#fafafa",
              border: "1px solid #d9d9d9",
              borderRadius: 6,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 12,
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 12, flex: 1 }}>
              <span
                style={{
                  fontWeight: 600,
                  color: "#1890ff",
                  minWidth: 24,
                }}
              >
                {index + 1}.
              </span>
              <span style={{ flex: 1 }}>{station.name || "未命名基站"}</span>
            </div>
            <Space size="small">
              <Button
                type="text"
                size="small"
                icon={<RiArrowUpLine />}
                disabled={index === 0}
                onClick={() => moveUp(index)}
              />
              <Button
                type="text"
                size="small"
                icon={<RiArrowDownLine />}
                disabled={index === items.length - 1}
                onClick={() => moveDown(index)}
              />
            </Space>
          </div>
        ))}
      </div>
    </Modal>
  );
};

export default ReorderModal;

